const headerWithoutToken = {
    headers: {
      'Content-Type': 'Application/json'
    },
  }
export default headerWithoutToken;